import { get as _get, post } from '@/util/request.js';

export type Path = {
	path: string;
	name: string;
	keys: Record<string, any>;
	options: Record<string, any>;
};
export type Rule = {
	id?: string;
	active: boolean;
	name: string;
	when: any[];
	then: any[];
};

export type Ruleset = {
	id: string;
	name: string;
	alias: string;
	paths: Path[];
	rules: Rule[];
};

export function update({
	id,
	name,
	paths,
	rules,
}: {
	id: string;
	name: string;
	paths: Path[];
	rules: Rule[];
}) {
	return post('bbay/ruleset/update', { id, name, paths, rules });
}

export function get({ id, alias }: { id?: string; alias?: string }): Promise<Ruleset> {
	if (id) return post('bbay/ruleset/get', { id });
	else if (alias) return post('bbay/ruleset/get', { alias });
	throw new Error('no id or alias');
}

export function list() {
	return _get('bbay/ruleset/list', null);
}

export type RunResult<T> = {
	facts: T;
	results: {
		accessedByActions: string[];
		accessedByPremises: string[];
		elapsed: number;
		fired: number;
		updated: string[];
	};
};

export function run<T>({
	ruleset,
	facts,
}: {
	ruleset: { id?: string; alias?: string; rev?: number };
	facts: T;
}): Promise<RunResult<T>> {
	return post('bbay/evaluator/run', { ruleset, facts });
}
